export const STATISTICS_CARD_PLACEHOLDER_VALUE = '--'
